<!--Desktop Interface-->
<div class="search-results-filters flex-grow-1">
  <span class="chosen-filter-description">VALGTE FILTRE:</span>
  <app-current-refinements
    [shownFilters]="shownFilters()">
  </app-current-refinements>
</div>
